import axios from "axios";
import { useContext } from "react";
import { IP } from "utils/Host"
import { TechnologyContext } from "context/TechnologyContext";
import { AppContext } from "context/AppContext";

export function useGant() {
  const techContext = useContext(TechnologyContext);
  const setGantStageGrupy = techContext.setGantStageGrupy;
  const gantStageGrupy = techContext.gantStageGrupy;
  const appContext = useContext(AppContext)
  const selectedProcesor = techContext.selectedProcesor
  const refreshGant = async (id) => {
    let procesor_id = id || 3;
    const res = await axios.get(
      IP + "API_0002_gantGrupy/" + sessionStorage.getItem("token")
    );

    setGantStageGrupy(...[res.data.filter(x => x.procesor_id == procesor_id)]);

  };


  const refreshGantAll = async (id) => {
    let procesor_id = id || 3;
    const res = await axios.get(
      IP + "API_0002_gantGrupy/" + sessionStorage.getItem("token")
    );

   
    // setGantStageGrupy(...[res.data.filter(x=>x.stan !=1)]);
    setGantStageGrupy(...[res.data.filter(x=>x.stan !=1)]);
  };


    const refreshGantZakonczone = async (procesor_id,data) => {
    const res = await axios.get(
      IP + "gantGrupyZakonczone/"+procesor_id+"/" +data+"/"+ sessionStorage.getItem("token")
    );


  //  console.log("Zamowienie_id"+zamowienie_id)
  //  console.table(res.data)
    setGantStageGrupy((prev) => [...prev, ...res.data]);
  };



    const generujPolaczenia = async (technologia_id = 0) => {
    const res = await axios.get(
      IP + "API_0001_gant_aktualizuj_arkusze_grup/"+technologia_id+"/" + sessionStorage.getItem("token")
    ).then((res) => {
    // console.log("procesor ",res.data)
    // fechparametryTechnologii
    refreshGantAll(1)


    });;
  };



  return {refreshGant,refreshGantAll,refreshGantZakonczone,generujPolaczenia};
}